import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';

@Component({
  selector: 'app-access-matrix-details-popup',
  templateUrl: './access-matrix-details-popup.component.html',
  styleUrls: ['./access-matrix-details-popup.component.scss']
})
export class AccessMatrixDetailsPopupComponent implements OnInit {
  popupName: any;
  listData: any = [];
  locationList: any = [];
  bandList: any = [];
  departmentList: any = [];
  designationList: any = [];
  updatedAt: any = [];
  createdAt: any = [];
  employeeList: any = [];
  accessMatrixId: any;
  loggedInUserRole: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AccessMatrixDetailsPopupComponent>,
    public dialog: MatDialog,
    public router: Router,
    private encryptionService: EncryptionService
  ) {}

  ngOnInit() {
    // console.log('this.data - - - ', this.data);
    this.popupName = this.data?.popupName;
    this.listData = this.data?.data;
    // console.log('Listdata is ..', this.listData);
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    if (this.popupName == 'Access') {
      this.accessMatrixId = this.data?.listMainData?.value?.id;
      this.locationList = this.listData?.location;
      this.bandList = this.listData?.band;
      this.departmentList = this.listData?.department;
      this.designationList = this.listData?.designation;
      this.employeeList = this.listData?.employeeDetails;
      this.createdAt = this.listData?.createdAt;
      // console.log('created at...', this.createdAt);
      this.updatedAt = this.listData?.updatedAt;
      // console.log('Updated at....', this.updatedAt);
    }
  }

  onClickEdit() {
    this.dialogRef.close();
    this.router.navigate(['/home/hrportal/accessmatrix', { id: this.accessMatrixId, operation: 'Edit' }]);
  }
}
